export default class TrackGrammarlyUsage {
  constructor(context) {
    this.context = context;
  }

  run() {
    if (document.getElementsByTagName('grammarly-extension').length > 0) {
      this.context.analytics.identifyUserTraits({ usesPluginGrammarly: true });
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/composer/track_grammarly_usage.js